export const JSON_ONE11 = {
   
    "encryptText": 

    {
    
        "aggregator_id": "safexpay",
        "merchant_id": 201705240001,
        "from_date": "2019-05-14T00:00:00.000Z",
        "to_date": "2019-05-14T00:00:00.000Z",
        "paymode": "All/CC/DC/NB/UP/WA",
        "status": "All",
        "reseller_id": 1,
        "pg_id": 500,
        "limit_from": 0,
        "limit_to": 3,
        "order_numbers": "All",
        "ag_references": "All",
        "request_type": "gerMislist"
    
    },
    "property1": "string",
    "property2": "string"
    }



